import { defineMessages } from 'react-intl';

// Main route
const usersScope = 't.page.users';

// Global scope
const globalScope = 't.global';

// Navigation
const navigationScope = 't.component.PortalAppNavigation';

// Global errors
const globalErrorsScope = 't.global.error';

export default defineMessages({
	// Main route
	creationDateFrom: {
		id: `${usersScope}.creationDateFrom`,
		defaultMessage: 'Data creazione',
	},
	deleteSubtitle: {
		id: `${usersScope}.deleteSubtitle`,
		defaultMessage: "dell'utente",
	},
	successfullyDelete: {
		id: `${usersScope}.successfullyDelete`,
		defaultMessage: 'Utente eliminato con successo',
	},
	failureDelete: {
		id: `${usersScope}.failureDelete`,
		defaultMessage: 'Eliminazione utente fallita',
	},
	detailTitle: {
		id: `${usersScope}.detailTitle`,
		defaultMessage: 'Dettaglio utente',
	},
	userData: {
		id: `${usersScope}.userData`,
		defaultMessage: 'Dati utente',
	},
	contactData: {
		id: `${usersScope}.contactData`,
		defaultMessage: 'Dati di contatto',
	},
	roleList: {
		id: `${usersScope}.roleList`,
		defaultMessage: 'Ruolo',
	},
	roleName: {
		id: `${usersScope}.roleName`,
		defaultMessage: 'Nome ruolo',
	},
	newUserTitle: {
		id: `${usersScope}.newUserTitle`,
		defaultMessage: 'Inserisci i dati utente',
	},
	userCreation: {
		id: `${usersScope}.userCreation`,
		defaultMessage: 'Crea utente',
	},
	userEditing: {
		id: `${usersScope}.userEditing`,
		defaultMessage: 'Modifica utente',
	},
	addRole: {
		id: `${usersScope}.addRole`,
		defaultMessage: 'Aggiungi ruolo',
	},
	assignNewRole: {
		id: `${usersScope}.assignNewRole`,
		defaultMessage: "Assegna un ruolo all'utente",
	},
	nexiAdminRole: {
		id: `${usersScope}.1`,
		defaultMessage: 'Amministratore Nexi',
	},
	groupAdminRole: {
		id: `${usersScope}.2`,
		defaultMessage: 'Amministratore Gruppo',
	},
	merchantAdminRole: {
		id: `${usersScope}.3`,
		defaultMessage: 'Amministratore Merchant',
	},
	userVasReaderRole: {
		id: `${usersScope}.4`,
		defaultMessage: 'Utente Lettore VAS',
	},
	roleData: {
		id: `${usersScope}.roleData`,
		defaultMessage: 'Dati Ruolo',
	},
	contactingEmailAddress: {
		id: `${usersScope}.contactingEmailAddress`,
		defaultMessage: 'Email di contatto',
	},

	// Navigation
	usersList: {
		id: `${navigationScope}.users.usersList`,
		defaultMessage: 'Elenco utenti',
	},
	usersManagement: {
		id: `${navigationScope}.users.usersManagement`,
		defaultMessage: 'Crea utente',
	},

	// Global
	abortLabelButton: {
		id: `${globalScope}.abort`,
		defaultMessage: 'Annulla',
	},
	createLabelButton: {
		id: `${globalScope}.create`,
		defaultMessage: 'Crea',
	},
	confirmLabelButton: {
		id: `${globalScope}.confirm`,
		defaultMessage: 'Conferma',
	},
	saveLabelButton: {
		id: `${globalScope}.save`,
		defaultMessage: 'Salva',
	},
	emptyString: {
		id: `${globalScope}.emptyString`,
		defaultMessage: ' ',
	},
	edit: {
		id: `${globalScope}.edit`,
		defaultMessage: 'Modifica',
	},
	warning: {
		id: `${globalScope}.warning`,
		defaultMessage: 'Attenzione',
	},
	subtitleDelete: {
		id: `${globalScope}.subtitleDelete`,
		defaultMessage: 'Sei sicuro di voler procedere alla cancellazione {element}?',
	},
	user: {
		id: `${globalScope}.user`,
		defaultMessage: 'Utente',
	},
	name: {
		id: `${globalScope}.name`,
		defaultMessage: 'Nome',
	},
	surname: {
		id: `${globalScope}.surname`,
		defaultMessage: 'Cognome',
	},
	mail: {
		id: `${globalScope}.mail`,
		defaultMessage: 'Email',
	},
	emailAddress: {
		id: `${globalScope}.emailAddress`,
		defaultMessage: 'Indirizzo email',
	},
	fax: {
		id: `${globalScope}.fax`,
		defaultMessage: 'Fax',
	},
	phone: {
		id: `${globalScope}.phone`,
		defaultMessage: 'Telefono',
	},
	cellphone: {
		id: `${globalScope}.cellphone`,
		defaultMessage: 'Cellulare',
	},
	profile: {
		id: `${globalScope}.profile`,
		defaultMessage: 'Profilo',
	},
	merchant: {
		id: `${globalScope}.merchant`,
		defaultMessage: 'Merchant',
	},
	shop: {
		id: `${globalScope}.shop`,
		defaultMessage: 'Negozio',
	},
	password: {
		id: `${globalScope}.password`,
		defaultMessage: 'Password',
	},
	repeatedPassword: {
		id: `${globalScope}.repeatedPassword`,
		defaultMessage: 'Ripeti Password',
	},
	addMerchant: {
		id: `${globalScope}.addMerchant`,
		defaultMessage: 'Aggiungi Merchant',
	},
	addGroup: {
		id: `${globalScope}.addGroup`,
		defaultMessage: 'Aggiungi Gruppo',
	},
	group: {
		id: `${globalScope}.group`,
		defaultMessage: 'Gruppo',
	},
	externalId: {
		id: `${globalScope}.externalId`,
		defaultMessage: 'ID Esterno',
	},
	creationDate: {
		id: `${globalScope}.creationDate`,
		defaultMessage: 'Data creazione',
	},

	//Errors
	invalidPassword1: {
		id: `${globalErrorsScope}.invalidPassword1`,
		defaultMessage: 'Password non valida',
	},
	invalidPassword2: {
		id: `${globalErrorsScope}.invalidPassword2`,
		defaultMessage: 'Password non valida',
	},
	invalidRepeatedPassword: {
		id: `${globalErrorsScope}.invalidRepeatedPassword`,
		defaultMessage: 'Le password non coincidono',
	},
	maxLength: {
		id: `${globalErrorsScope}.maxLength`,
		defaultMessage: 'Lunghezza massima ({number}) superata',
	},
	fieldRequested: {
		id: `${globalErrorsScope}.fieldRequested`,
		defaultMessage: 'Campo obbligatorio',
	},
	invalidDate: {
		id: `${globalErrorsScope}.invalidDate`,
		defaultMessage: 'Data non valida',
	},
	theSecondDateIsMinorThanFirst: {
		id: `${globalErrorsScope}.theSecondDateIsMinorThanFirst`,
		defaultMessage: 'Data di fine troppo piccola',
	},
	fillFirstDateToContinueValidation: {
		id: `${globalErrorsScope}.fillFirstDateToContinueValidation`,
		defaultMessage: "Data d'inizio mancante",
	},
	invalidEmail: {
		id: `${globalErrorsScope}.invalidEmail`,
		defaultMessage: 'Email non valida',
	},
});
